import { render, staticRenderFns } from "./VDateField.vue?vue&type=template&id=771bb648&scoped=true&lang=pug&"
import script from "./VDateField.vue?vue&type=script&lang=js&"
export * from "./VDateField.vue?vue&type=script&lang=js&"
import style0 from "./VDateField.vue?vue&type=style&index=0&id=771bb648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771bb648",
  null
  
)

export default component.exports